import { render, staticRenderFns } from "./TheHomeAddSpace.vue?vue&type=template&id=5a0d81e0&scoped=true&"
import script from "./TheHomeAddSpace.vue?vue&type=script&lang=js&"
export * from "./TheHomeAddSpace.vue?vue&type=script&lang=js&"
import style0 from "./TheHomeAddSpace.vue?vue&type=style&index=0&id=5a0d81e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0d81e0",
  null
  
)

export default component.exports